import React from 'react';
import { useQuery } from "@tanstack/react-query";
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import { getHorseDetail } from "data/Querys";
import Loader from "components/general/Loader";
import NotAvailable from "components/common/NotAvailable";
import HorseInfo from "../components/common/participants/HorseInfo";
import BioAnchors from 'components/common/participants/BioAnchors';
import HorseBioData from 'components/common/participants/HorseBioData';
import { usePreparePayLoad } from 'components/common/ocs-custom-events/helpers';
import FireOnContentLoadOCS from 'components/general/FireOnContentLoadOCS';
import { useScrollToTop } from 'helpers/utils';

function Horse() {
    const params = useUrlFriendlyToParameters()
    let paramsURL = { ...params }
    const payloadParams = usePreparePayLoad()
    useScrollToTop();

    //Get Data
    const { data, isError, isLoading } = useQuery(
        {
            queryKey: ['horseDetail', paramsURL['mirs_competition'], paramsURL['mirs_language'], paramsURL['mirs_code']],
            queryFn: getHorseDetail,
            enabled: true
            // notifyOnChangeProps: [id] | "tracked"
        });

    if (isError) {
        return <NotAvailable label="LabelNoDataAvailable" />;
    }
    if (isLoading) {
        return <Loader />;
    }
    if (!data?.horse) {
        return <NotAvailable label="LabelNoDataAvailable" />
    }

    return (
        <>
            <FireOnContentLoadOCS params={params} data={data} payloadParams={payloadParams} type='horse' />
            <div className='mirs-page-container'>
                <div className="wrsBiosDetail__panel">
                    <div className="bios-personalinfo">
                        <HorseInfo data={data} />
                        {data?.horse?.horseBio && <BioAnchors data={data} />}
                    </div>
                    {<HorseBioData data={data} />}
                </div>
            </div>
        </>
    );
};

export default Horse;

